<div class="toggle-filter">
  <mat-slide-toggle
    [(ngModel)]="value"
    (ngModelChange)="onChange()"
  ></mat-slide-toggle>
  <div class="toggle-filter-label">{{ this.label }}</div>
</div>
